/*
 * CHELPKS1-16: Minimal JS for landing page enhancements
 */
document.addEventListener('DOMContentLoaded', function () {

  /* Final section: add dark sage class */
  var sections = document.querySelectorAll('.shopify-section .rich-text');
  if (sections.length > 0) {
    var last = sections[sections.length - 1];
    var parent = last.closest('.shopify-section');
    if (parent) parent.classList.add('pk-final-close');
  }

  /* Variant swatches: set background colors based on label text */
  var swatchColors = {
    'cream': '#ead9b8',
    'sage': '#6b8b6e',
    'rose': '#d68b9b',
    'sky': '#8db5c8'
  };

  function applySwatchColors() {
    var labels = document.querySelectorAll('.product-form__input--pill label');
    labels.forEach(function (label) {
      var text = label.textContent.trim().toLowerCase();
      Object.keys(swatchColors).forEach(function (key) {
        if (text.indexOf(key) !== -1) {
          label.style.setProperty('background-color', swatchColors[key], 'important');
        }
      });
    });
  }

  applySwatchColors();

  /* Re-apply swatch colors when Dawn re-renders the variant picker.
     Use a debounce to avoid infinite loop from our own style changes. */
  var applyTimeout = null;
  var productForm = document.querySelector('.product-form');
  if (productForm) {
    var observer = new MutationObserver(function (mutations) {
      /* Only re-apply if actual DOM nodes changed, not just attributes */
      var dominated = mutations.some(function (m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (dominated) {
        clearTimeout(applyTimeout);
        applyTimeout = setTimeout(applySwatchColors, 50);
      }
    });
    observer.observe(productForm, { childList: true, subtree: true });
  }

  /* CTA buttons that link to this product page: convert to scroll-to-top */
  var currentPath = window.location.pathname;
  document.querySelectorAll('a.button').forEach(function (link) {
    var href = link.getAttribute('href');
    if (href && (href === currentPath || href.indexOf('/products/prepared-kids') !== -1)) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  });
});
